export const AUTH_TOKEN_COOKIE = "access_token";
export const FALLBACK_TOKEN_COOKIES = ["jwt_token", "workspace_token"] as const;
export const USER_STORAGE_KEY = "hub_web:user";
/** Horário (ms) da última atividade do usuário; compartilhado entre abas. */
export const LAST_ACTIVITY_STORAGE_KEY = "hub_web:last-activity";
/** Sinal entre abas: a sessão foi encerrada por inatividade. */
export const IDLE_LOGOUT_STORAGE_KEY = "hub_web:idle-logout";
export const LAYOUT_STORAGE_KEY = "hub_web:layout";
export const USERS_TABLE_DENSITY_KEY = "hub_web:users-table-density";
export const AUDIT_TABLE_DENSITY_KEY = "hub_web:audit-table-density";
export const EMBARCACOES_TABLE_DENSITY_KEY = "hub_web:embarcacoes-table-density";
export const PERMISSIONS_TABLE_DENSITY_KEY = "hub_web:permissions-table-density";
export const ROLES_TABLE_DENSITY_KEY = "hub_web:roles-table-density";
export const MOEDAS_TABLE_DENSITY_KEY = "hub_web:moedas-table-density";
export const ESCOPOS_PADRAO_TABLE_DENSITY_KEY = "hub_web:escopos-padrao-table-density";
export const CARGA_TRABALHO_INDICATORS_KEY = "hub_web:carga-trabalho-indicators";
export const PROFISSIONAIS_TABLE_DENSITY_KEY = "hub_web:profissionais-table-density";
export const HISTORICO_SIMULACAO_TABLE_DENSITY_KEY = "hub_web:historico-simulacao-table-density";
/** Prefixo da chave de filtros salvos: `filtros-salvos:<tela>:<usuario>`. */
export const SAVED_FILTERS_KEY_PREFIX = "filtros-salvos";
export const OBRAS_TABLE_DENSITY_KEY = "hub_web:obras-table-density";
export const OBRAS_TABLE_COLUMNS_KEY = "hub_web:obras-table-columns";
export const FINANCEIRO_OBRAS_TABLE_DENSITY_KEY = "hub_web:financeiro-obras-table-density";
export const PLANEJAMENTO_CONTROLE_TABLE_DENSITY_KEY =
  "hub_web:planejamento-controle-table-density";
export const FINANCEIRO_OBRAS_TABLE_COLUMNS_KEY = "hub_web:financeiro-obras-table-columns";
/** Marca que as preferências da tabela de Obras já estão no formato do `useTableSettings` do DS. */
export const OBRAS_TABLE_SETTINGS_FORMAT_KEY = "hub_web:obras-table-settings-format";
